import React from "react";
import Cart from "../Cart";
import Checkout from "../Checkout";
import { Container } from "./CheckoutPage.styles";

const CheckoutPage = () => {
  return (
    <Container>
      <Cart />
      <Checkout />
    </Container>
  );
};

export default CheckoutPage;
